import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import Camera from "../appComponents/Camera";
import InputField from "../inputComponents/InputField";
import SelectField from "../inputComponents/SelectField";

const ModalPostStaff = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BUTTON_NAME = "Create Account";
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const IMAGELOCATION = "upload/admin_passports/emptyImage.jpg";

  //Fetches all Form Data
  const [allformData, setAllFormData] = useState({
    input: {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      salary: null,
      accountNo: null,
      bank: null,
      password: null,
      validity: null,
    },
    select: {
      status: "",
      department: null,
      authority: null,
      gender: null,
      location: null,
      //shift: null,
    },
  });

  const [camera, setCamera] = useState({
    passport: null,
    cameraValue: IMAGELOCATION,
    changeValue: 0,
    btnLoading: BUTTON_NAME,
  });

  function extractColumn(arr, column) {
    return arr.map((x) => x[column]);
  }
  const [options, setOptions] = useState({
    status: [],
    authority: [],
    gender: [],
    location: [],
    //shift: [],
    department: [],
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setAllFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  useEffect(() => {
    setCamera((prev) => ({
      ...prev,
      passport: props.editposts.passport,
    }));

    (async () => await populateSelectMenu())();
  }, [props.editposts]);

  const populateSelectMenu = async () => {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}inputdepartment?status[eq]=Active&serviceCharges[gt]=1`,
        ),
        axios.get(`${BASE_URL}inputlocation?status[eq]=Active`),
        axios.get(
          `${BASE_URL}inputcomponents?type[eq]=activeStatus&activeStatus[eq]=Active`,
        ),
        //axios.get(`${BASE_URL}inputshift?status[eq]=Active`),
      ]);

      const [departmentData, locationData, StatusData] = responses;

      // populate the select menu
      const populateSelect = (colume, columeObject, columeName) => {
        if (columeObject?.data?.status === 200) {
          return setOptions((prev) => ({
            ...prev,
            [colume]: extractColumn(columeObject.data.allData, columeName),
          }));
        }
      };

      populateSelect("department", departmentData, "departmentName");
      populateSelect("location", locationData, "location");
      populateSelect("status", StatusData, "productCategory");
      //populateSelect("shift", ShiftData, "shift");
    } catch (error) {
      swal("Error", "Error fetching Registry Data", "error");
      console.log("Error fetching Registry Data:", error);
    }
  };
  async function submitUpload(event) {
    event.preventDefault();
    setCamera((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));

    let formData;

    formData = new FormData();

    formData.append("firstName", allformData.input.firstName);
    formData.append("lastName", allformData.input.lastName);
    formData.append("department", allformData.select.department);
    formData.append("location", allformData.select.location);
    //formData.append("shift", allformData.select.shift);
    formData.append("sex", allformData.select.gender);
    formData.append("email", allformData.input.email);
    formData.append("phone", allformData.input.phone);
    formData.append("password", allformData.input.password);
    formData.append("status", allformData.select.status);
    formData.append("salary", allformData.input.salary);
    formData.append("accountNo", allformData.input.accountNo);
    formData.append("bank", allformData.input.bank);
    formData.append("authority", allformData.select.authority);
    formData.append("passport", camera.cameraValue);
    formData.append("validity", allformData.input.validity);
    formData.append("type", "staff");
    await axios.get(`sanctum/csrf-cookie`).then((response) => {
      try {
        axios.post(`${BASE_URL}inputname`, formData).then((res) => {
          if (res?.data?.status === 200) {
            swal("Success", res.data.message, "success");

            setCamera((prev) => ({
              ...prev,
              btnLoading: BUTTON_NAME,
            }));

            props.formCleanners();
            props.setCloseModal(true);
          } else if (res?.data?.status === 500) {
            swal("Oops!", res.data.message, "error");
          }
        });
      } catch (error) {
        swal("Oops!", "Failed", "error");
        console.log(error.response.data);
      }
    });
  }

  const uploadImage = () => {
    setCamera((prev) => ({
      ...prev,
      changeValue: 1,
    }));
  };

  return (
    <>
      {camera.changeValue === 0 && (
        <>
          <form onSubmit={submitUpload} encType="multipart/form-data">
            <div className="row">
              <div className="col-md-12 mb-3">
                <div className="card">
                  <div className="card-header text-white bg-success p-3">
                    <i className="fa fa-newspaper"></i> CREATE STAFF ACCOUNT
                  </div>
                  <div className="card-body">
                    <div className="row m-1">
                      <InputField
                        label="* Email"
                        name="email"
                        size="3"
                        placeholder="Please Type Email Address"
                        required="required"
                        value={allformData.input.email}
                        type="email"
                        onChange={updateFormData}
                        icon="fa fa-envelope"
                      />

                      <InputField
                        label="* Phone"
                        name="phone"
                        size="3"
                        placeholder="Please Type Phone Number"
                        required="required"
                        value={allformData.input.phone}
                        type="text"
                        onChange={updateFormData}
                        icon="fa fa-phone"
                      />

                      <SelectField
                        label="* Status"
                        name="status"
                        size="3"
                        placeholder="Please Select A Status"
                        required="required"
                        value={allformData.select.status}
                        options={options.status}
                        switchOptions={0}
                        onChange={updateFormData}
                        icon="fa fa-hand-pointer-o"
                      />

                      <InputField
                        label="* FirstName"
                        name="firstName"
                        size="3"
                        placeholder="Please Type in The First Name"
                        required="required"
                        value={allformData.input.firstName}
                        type="text"
                        onChange={updateFormData}
                        icon="fa fa-user"
                      />

                      <InputField
                        label="* LastName"
                        name="lastName"
                        size="3"
                        placeholder="Please Type in The Last Name"
                        required="required"
                        value={allformData.input.lastName}
                        type="text"
                        onChange={updateFormData}
                        icon="fa fa-user"
                      />

                      <SelectField
                        label="* Authority"
                        name="authority"
                        size="3"
                        placeholder="Please Select an Authority"
                        required="required"
                        value={allformData.select.authority}
                        options={[
                          { item: "STAFF", values: "0" },
                          { item: "DESK OFF.", values: "1" },
                          { item: "WEB ADMIN", values: "2" },
                          { item: "ADMIN", values: "3" },
                          { item: "FULL ADMIN", values: "4" },
                        ]}
                        switchOptions={1}
                        onChange={updateFormData}
                        icon="fa fa-sign-in"
                      />

                      <InputField
                        label="* ID Card Validity"
                        name="validity"
                        size="3"
                        placeholder="Please Select Validity Period"
                        required="required"
                        value={allformData.input.validity}
                        type="date"
                        onChange={updateFormData}
                        icon="fa fa-id-card"
                      />

                      <SelectField
                        label="* Location"
                        name="location"
                        size="3"
                        placeholder="Please Select An Office Location"
                        required="required"
                        value={allformData.select.location}
                        options={options.location}
                        switchOptions={0}
                        onChange={updateFormData}
                        icon="fa fa-location-arrow"
                      />

                      {/* <SelectField
                        label="* Shift"
                        name="shift"
                        size="3"
                        placeholder="Please Select A Shift"
                        required="required"
                        value={allformData.select.shift}
                        options={options.shift}
                        switchOptions={0}
                        onChange={updateFormData}
                        icon="fa fa-clock-o"
                      /> */}

                      <SelectField
                        label="* Department"
                        name="department"
                        size="3"
                        placeholder="Please Select A Department"
                        required="required"
                        value={allformData.select.department}
                        options={options.department}
                        switchOptions={0}
                        onChange={updateFormData}
                        icon="fa fa-table"
                      />

                      <SelectField
                        label="Gender"
                        name="gender"
                        size="3"
                        placeholder="Please Select A Gender"
                        required=""
                        value={allformData.select.gender}
                        options={[
                          { item: "Male", values: "male" },
                          { item: "Female", values: "female" },
                        ]}
                        switchOptions={1}
                        onChange={updateFormData}
                        icon="fa fa-users"
                      />

                      <InputField
                        label="Salary"
                        name="salary"
                        size="3"
                        placeholder="Please Type The Salary"
                        required=""
                        value={allformData.input.salary}
                        type="number"
                        onChange={updateFormData}
                        icon="fa fa-money"
                      />

                      <InputField
                        label="AccountNo"
                        name="accountNo"
                        size="3"
                        placeholder="Please Type AccountNo"
                        required=""
                        value={allformData.input.accountNo}
                        type="number"
                        onChange={updateFormData}
                        icon="fa fa-bank"
                      />

                      <InputField
                        label="Bank"
                        name="bank"
                        size="3"
                        placeholder="Please Type in The Bank"
                        required=""
                        value={allformData.input.bank}
                        type="text"
                        onChange={updateFormData}
                        icon="fa fa-bank"
                      />

                      <InputField
                        label="Password"
                        name="password"
                        size="3"
                        placeholder="Please Typy A Password"
                        required=""
                        value={allformData.input.password}
                        type="password"
                        onChange={updateFormData}
                        icon="fa fa-lock"
                      />

                      <div className="col-lg-3">
                        <div className="form-group mt-2">
                          <div
                            className=" d-flex flex-row"
                            onClick={uploadImage}
                          >
                            <img
                              src={BACKEND_URL + IMAGELOCATION}
                              alt=""
                              width={60}
                              height={70}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group mt-2">
                          <button className="btn btn-primary col-lg-12 mt-4">
                            <div className="d-flex align-items-center justify-content-center w-100">
                              <i className="fa fa-edit m-1"></i>
                              <span>{camera.btnLoading}</span>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
      {camera.changeValue === 1 && (
        <>
          <div className="col-lg-5">
            <div className="form-group mt-2">
              <div className=" d-flex flex-row">
                <Camera
                  setCameraValue={setCamera}
                  setParthValue={1} //1 is upload to (upload/admin_passports/), 2 is (upload/camera/)
                  setChangePage={0}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default ModalPostStaff;
